import React, { Component } from "react";
import Input from "../common/Input";
import { NavLink, Redirect } from "react-router-dom";
import AccountType from "./account-type";
import logo from "../assets/rizevoIcon.svg";
import { connect } from "react-redux";
import { register, postOptions } from "../common/server";
import HomeSvg from "../login/HomeSvg";
import Select from "../common/Select";

export default connect()(
  class Login extends Component {
    state = {
      redirect: false,
      invite_code: '',
      active_step: 1,
      name: "",
      referral_source: "",
      referral_other: "",
      errors: {
        first_name: "",
        last_name: "",
        phone_number: "",
        email: "",
        password: "",
        referral_source: "",
        referral_other: "",
      },
    };


    step_one = React.createRef();
    step_two = React.createRef();
    steps = [];

    nextStep = () => {
      this.setState({ active_step: this.state.active_step + 1 });
      this.setState({ account_type: 'business_owner' });
      window.scrollTo(0, 0);
    };

    handleSelectChange = (e) => {
      const value = e?.target?.value;
      this.setState({
        referral_source: value,
        referral_other: value === "Other" ? this.state.referral_other : "",
      });
      localStorage.setItem("referral_source", value);
    };

    handleOtherChange = (e) => {
      const value = e?.target?.value;
      this.setState({ referral_other: e.target.value });
      localStorage.setItem("referral_other", value);
    };

    submitForm = (ev) => {
      ev.preventDefault();
      const form = ev.currentTarget;
      const formButton = form.querySelector("button[type=submit]");
      formButton.classList.add("loading");

      // clear errors
      let errors = {};

      // validate referral source (only for non-invited signups)
      if (!this.state.invite_code) {
        if (!this.state.referral_source) {
          errors.referral_source = "Please select an option";
        }

        if (
          this.state.referral_source === "Other" &&
          !this.state.referral_other.trim()
        ) {
          errors.referral_other = "Please specify how you found us";
        }
      }

      this.setState({ errors });

      if (Object.keys(errors).length > 0) {
        formButton.classList.remove("loading");
        return;
      }

      if (form.checkValidity() === true) {
        let formData = {
          first_name: form.first_name.value,
          last_name: form.last_name.value,
          email: form.email.value,
          phone_number: form.phone_number.value,
          password: form.password.value,
          account_type: this.state.account_type,
        };

        fetch(
          register,
          Object.assign({}, postOptions, { body: JSON.stringify(formData) })
        )
          .then((response) => {
            formButton.classList.remove("loading");
            if (response.status.toString()[0] === 2) {
              this.setState({ name: formData.first_name });
            }
            return response.json();
          })
          .then((obj) => {
            if (obj.success === false) {
              const errorsCopy = { ...this.state.errors };
              obj.errors.map((error) => {
                errorsCopy[error.field] = error.message;
              });
              this.setState({ errors: errorsCopy });
            }

            if (obj.data?.token) {
              this.props.dispatch({
                type: "LOGIN_DATA",
                data: { data: obj.data },
              });
              setTimeout(this.done, 0);
            }
          });
      } else {
        form.reportValidity();
        formButton.classList.remove("loading");
      }
    };

    done = (ev) => {
      if (ev) ev.preventDefault();
      this.setState({ redirect: "/onboarding" });
    };

    componentDidMount = () => {
      localStorage.removeItem("referral_source");
      localStorage.removeItem("referral_other");
      const query = new URLSearchParams(this.props.location.search);
      const invite_code = query.get("invite_code");
      const account_type = invite_code
        ? "business_team_member"
        : "business_owner";

      this.setState({ account_type, invite_code });
      this.steps = [this.step_one.current, this.step_two.current];
    };

    render() {
      return (
        <div className="login-page-container">
          <div className="login-page-container-header flex">
            <a href="https://kindlybook.com" className="flex co-pink">
              <HomeSvg /> Go to website
            </a>

            <div>
              <NavLink
                to={{ pathname: "/login", search: this.props.location.search }}
                className="default-btn"
              >
                Sign In
              </NavLink>
            </div>
          </div>

          <div className="form-page login-page">
            {this.state.redirect ? (
              <Redirect
                to={{
                  pathname: this.state.redirect,
                  search: this.props.location.search,
                }}
              />
            ) : (
              ""
            )}

            <div className="heading">
              <img className="logo" src={logo} alt="" />
              <h1>Create your free business account</h1>
              <p>Kindlybook helps you book appointments and get paid easily.</p>

              <div className="footer dsk">
                Have an account?{" "}
                <NavLink
                  to={{
                    pathname: "/login",
                    search: this.props.location.search,
                  }}
                  className="underline"
                >
                  Sign in instead
                </NavLink>
              </div>
            </div>

            <div
              style={{
                display: this.state.active_step === 1 ? "block" : "none",
              }}
            >
              <div className="form-container card" ref={this.step_two}>
                <form className="form_step" onSubmit={this.submitForm}>

                  <Input
                    label="first name"
                    name="first_name"
                    placeholder="Enter first name here"
                    type="text"
                    error={this.state.errors.first_name}
                    required
                  />
                  <Input
                    label="last name"
                    type="text"
                    name="last_name"
                    placeholder="Enter surname here"
                    error={this.state.errors.last_name}
                    required
                  />
                  <Input
                    label="email address"
                    type="email"
                    name="email"
                    placeholder="e.g. you@example.com"
                    error={this.state.errors.email}
                    required
                  />
                  <Input
                    label="phone number"
                    type="number"
                    name="phone_number"
                    placeholder="e.g. 0812 345 6789"
                    error={this.state.errors.phone_number}
                    required
                  />
                  <Input
                    label="create password"
                    type="password"
                    name="password"
                    placeholder="Enter password here"
                    error={this.state.errors.password}
                    required
                  />

                  {/* REFERRAL SOURCE - only show for non-invited signups */}
                  {!this.state.invite_code && (
                    <>
                      <div className="form-group">
                        <Select label="How did you find out about Kindlybook?"
                          value={this.state.referral_source}
                          onChange={this.handleSelectChange}
                          className="input"
                          required
                        >
                          <option value="">Select an option</option>
                          <option value="From a Friend">From a Friend</option>
                          <option value="Google Search">Google Search</option>
                          <option value="AI Suggestion">AI Suggestion</option>
                          <option value="Training Session">Training Session</option>
                          <option value="Instagram">Instagram</option>
                          <option value="Tiktok">Tiktok</option>
                          <option value="X (Twitter)">X (Twitter)</option>
                          <option value="Other">Other</option>
                        </Select>
                        {this.state.errors.referral_source && (
                          <small className="error">
                            {this.state.errors.referral_source}
                          </small>
                        )}
                      </div>

                      {this.state.referral_source === "Other" && (
                        <Input
                          label="Tell us how you found us"
                          type="text"
                          value={this.state.referral_other}
                          onChange={this.handleOtherChange}
                          required
                        />
                      )}
                    </>
                  )}

                  <div className="flex center space-btw">
                    <button className="default" type="submit">
                      Continue
                    </button>
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      );
    }
  }
);